import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import type { MPARequest } from '@repo/api-gw-sdk';
import { CopyToClipboardButton } from '@/components/buttons/copyToClipboardButton';
import { MainDialog } from '@/components/dialogs/mainDialog';
import { JsonViewerPanel } from '@/components/shared/jsonViewer';
import { parseJson } from '@/utils/string';
const parseBody = (request: MPARequest): object | null => request.requestBody ? parseJson<object>(request.requestBody) ?? null : null;
export const MpaRequestDetails = t0 => {
  const $ = _c(18);
  const {
    request
  } = t0;
  let t1;
  if ($[0] !== request) {
    t1 = parseBody(request);
    $[0] = request;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const body = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "16px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "baseline",
      gap: "8px",
      fontFamily: "monospace"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontFamily: "monospace"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== request.requestMethod) {
    t5 = <Typography variant="h4" sx={t4}>{request.requestMethod}</Typography>;
    $[5] = request.requestMethod;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      fontFamily: "monospace",
      wordBreak: "break-all"
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== request.requestPath) {
    t7 = <Typography variant="body1" sx={t6}>{request.requestPath}</Typography>;
    $[8] = request.requestPath;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <Stack direction="row" sx={t3}>{t5}{t7}</Stack>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== body) {
    t9 = body ? <JsonViewerPanel data={body} /> : <Typography variant="body1" sx={{
      color: "text.secondary"
    }}>Request body is empty</Typography>;
    $[13] = body;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <Stack sx={t2}>{t8}{t9}</Stack>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export const MpaRequestDetailsDialog = t0 => {
  const $ = _c(25);
  const {
    isOpen,
    onClose,
    request
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== isOpen || $[1] !== onClose || $[2] !== request) {
    const body = parseBody(request);
    T0 = MainDialog;
    t3 = isOpen;
    t4 = false;
    if ($[9] !== onClose) {
      t5 = {
        title: "Request details",
        onClose
      };
      t1 = {
        text: "Close",
        onClick: onClose,
        "data-testid": "close-mpa-request-json-viewer"
      };
      $[9] = onClose;
      $[10] = t1;
      $[11] = t5;
    } else {
      t1 = $[10];
      t5 = $[11];
    }
    t2 = body ? <CopyToClipboardButton textToCopy={JSON.stringify(body)} buttonLabel="Copy" /> : undefined;
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = request;
    $[3] = T0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    T0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t2) {
    t6 = {
      primaryButton: t1,
      children: t2
    };
    $[12] = t1;
    $[13] = t2;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      minHeight: "350px",
      maxHeight: "80%",
      overflow: "auto"
    };
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== request) {
    t8 = <Stack className="px-[40px]" sx={t7}><MpaRequestDetails request={request} /></Stack>;
    $[16] = request;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== T0 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t8) {
    t9 = <T0 isOpen={t3} isLoading={t4} header={t5} footer={t6}>{t8}</T0>;
    $[18] = T0;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};